<div class="badges" *ngIf="type !== 'small'">
	<span *ngIf="+product.delivery === 3" class="badge fastdelivery">Krótki Lead Time</span>
	<span *ngIf="+discounted_price > 0" class="badge discount" i18n>promocja</span>
	<span *ngIf="+product.day" class="badge feat" i18n>polecamy</span>
	<span *ngIf="lead_time" class="badge bestseller" i18n>Short Lead Time</span>
	<span *ngIf="+product.bestseller && isLoggedIn" class="badge bestseller" i18n="@@promountil">promocja do 20.09.2024</span>
	<span *ngIf="+product.new" class="badge new" i18n>nowość</span>
</div>

<div class="favorite flx-col flx-gap-half">
	<button *ngIf="type != 'favorite'" class="icon-button" aria-label="Do ulubionych" (click)="addToFavorites(product.variants[product.variant_selected].id)"><svg class="icon icon-xl icon-heart-o"><use xlink:href="#icon-heart-o"></use></svg></button>
	<label  *ngIf="type == 'favorite'"class="checkbox"><input type="checkbox" (click)="selectProduct(product.variants[product.variant_selected].id)"/></label>
	<button *ngIf="type == 'favorite'" class="icon-button" aria-label="Do ulubionych" (click)="removeFromFavorites(product.variants[product.variant_selected].id)"><svg class="icon"><use xlink:href="#icon-trash"></use></svg></button>	
</div>

<div *ngIf="tilting" class="tilting tilting_{{tilting}} flx-col flx-cntr-cntr">
	<img src="/assets/tilt{{tilting}}.svg" [alt]="tilting"/>
</div>

<a (click)="navigate()" [routerLink]="link" [queryParams]="params" aria-label="Produkt" class="product-image">
	<app-image *ngIf="product.id > 0" [url]="[cdn+'/products/'+product.photos_directory+'/medium_'+product.photo, cdn+'/products/'+product.photos_directory+'/card_'+product.photo]"></app-image>
</a>
<div class="card-product-content-wrap">
	<div class="card-product-content">
		<a *appShowB2b="'show_prices'" (click)="navigate()" [routerLink]="link" [queryParams]="params">
			<app-price
			[id]="product.id"
			[price]="product.variants[product.variant_selected].price"
			[price_promo]="product.variants[product.variant_selected].price_promo"
			[currency]="product.variants[product.variant_selected].currency"
			[quantity]="1"
			[tax]="product.variants[product.variant_selected].tax"
			[discounts]="discounts"
			[manufacturer]="product.id_manufacturer"
			[series]="product.series"
			[category]="product.categories"></app-price>
		</a>
		<a (click)="navigate()" [routerLink]="link" [queryParams]="params">
			<h3 [innerHtml]="product.title"></h3>
			<p [innerHtml]="product.extra_1 ? product.extra_1 : product.series"></p>
			<app-decoder *ngIf="+product.configurable == 1" [code]="product.extra_1 ? product.extra_1 : product.series" [type]="[1,3]"></app-decoder>
		</a> 	
	</div>
	<div class="card-product-content-mock">
		<a *appShowB2b="'show_prices'" (click)="navigate()" [routerLink]="link" [queryParams]="params">
			<app-price
			[id]="product.id"
			[price]="product.variants[product.variant_selected].price"
			[price_promo]="product.variants[product.variant_selected].price_promo"
			[currency]="product.variants[product.variant_selected].currency"
			[quantity]="1"
			[tax]="product.variants[product.variant_selected].tax"
			[discounts]="discounts"
			[manufacturer]="product.id_manufacturer"
			[series]="product.series"
			[category]="product.categories"></app-price>
		</a>
			<h3>&nbsp;</h3>
			<p>&nbsp;</p>
	</div>
</div>
<div *appShowB2b="'allow_orders'" class="card-product-actions">
	<div>
		<button class="stroked-button btn-quantity" (click)="minus()"><svg class="icon icon-minus"><use xlink:href="#icon-minus"></use></svg></button>
		<input class="input-quantity" [value]="quantity" (change)="changeQuantity($event)">
		<button class="stroked-button btn-quantity" (click)="plus()"><svg class="icon icon-plus"><use xlink:href="#icon-plus"></use></svg></button>
	</div>
	<button class="flat-button primary fat" (click)="addToCart()" i18n>DO KOSZYKA</button>
</div>